import React from 'react';
import { styled } from '../../shared/Theme/theme';
import { Navigate, Route, useNavigate, Routes, useLocation } from 'react-router-dom';
import { Location } from 'react-router-dom';
import CreateNew from './components/CreateNew';
import Pricing from './components/Pricing';
import ConfirmEmail from './components/ConfirmEmail';
import SetupCompany from './components/SetupCompany';
import CreateUserForm from './components/CreateUserForm';
import RegistrationSuccess from './components/RegistrationSuccess';
import { getStartedCreateCompanyPayload } from '../../../models/entities/company/getStartedCreateCompanyPayload';
import logo from '../../../static/common/logo.svg';
import { LocationStateType } from './GetStartedPageConnected';

type GetStartedPageProps = {
    localization: any;
    sendEmailValidation: (email: string) => Promise<boolean>;
    validateEmail: (email: string, pinCode: string, pricingPlanId?: string, underForwarderToken?: string) => Promise<string>;
    createCompany: (payload: getStartedCreateCompanyPayload) => Promise<void>;
    validateCompanyName: (name: string) => Promise<boolean>;
    isSendingValidationEmail: boolean;
    isValidateEmail: boolean;
    isCreateCompany: boolean;
    isValidateCompanyName: boolean;
    underForwarderToken?: string;
};

const GetStartedPage = ({
    localization,
    sendEmailValidation,
    validateEmail,
    createCompany,
    validateCompanyName,
    isSendingValidationEmail,
    isValidateEmail,
    isCreateCompany,
    isValidateCompanyName,
    underForwarderToken
}: GetStartedPageProps) => {
    const navigate = useNavigate();
    const location = useLocation() as Location<LocationStateType>;

    return (
        <PageContainer>
            <LogoImg src={logo} />

            <Routes>
                <Route path="pricing" element={
                    <Pricing
                        onSelectPlan={(planId) => navigate('/getstarted', { state: { pricingPlanId: planId } })}
                    />
                } />
                <Route path="" element={
                    <CreateNew
                        localization={localization.create_new}
                        sendEmailValidation={sendEmailValidation}
                        isSendingValidationEmail={isSendingValidationEmail}
                    />
                } />
                <Route path="confirmEmail" element={
                    <ConfirmEmail
                        localization={localization.confirm_email}
                        validateEmail={validateEmail}
                        isValidateEmail={isValidateEmail}
                        underForwarderToken={underForwarderToken}
                    />
                } />
                <Route path="setupCompany" element={
                    <SetupCompany
                        localization={localization.setup_company}
                        validateCompanyName={validateCompanyName}
                        isValidateCompanyName={isValidateCompanyName}
                    />
                } />
                <Route path="provideDetails" element={
                    <CreateUserForm
                        localization={localization.create_user}
                        createCompany={createCompany}
                        isCreateCompany={isCreateCompany}
                    />
                } />
                <Route path="success" element={
                    <RegistrationSuccess localization={localization.registration_success} />
                } />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </PageContainer>
    );
};

const PageContainer = styled.div`
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

const LogoImg = styled.img`
    width: 200px;
    padding: 48px 0 40px;
`;

export default GetStartedPage;
